export default function boolToHumanReadable(bool: boolean): string {
  return bool ? 'Yes' : 'No'
}
